/**
 * GA4 event tracking helpers.
 * gtag.js is loaded from index.html (deferred). All events are user-triggered —
 * never fired on page load.
 */

type GtagParams = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const isDev = import.meta.env.DEV;

export const trackEvent = (eventName: string, params: GtagParams = {}) => {
  const clean: GtagParams = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== "") clean[key] = value;
  });

  if (isDev) {
    // eslint-disable-next-line no-console
    console.log("[GA4]", eventName, clean);
  }

  try {
    window.gtag?.("event", eventName, clean);
  } catch {
    /* analytics must never break the UI */
  }
};

/** Fired when a user receives a result from any calculator on the site. */
export const trackCalculatorComplete = (calculatorName: string, city?: string) =>
  trackEvent("calculator_complete", { calculator_name: calculatorName, city });

/** Fired on every outbound click to an external real-estate portal. */
export const trackOutboundPortalClick = (portalName: string, sourcePage: string) =>
  trackEvent("outbound_portal_click", { portal_name: portalName, source_page: sourcePage });

/** Fired when the portal finder flow reaches its results step. */
export const trackPortalFinderComplete = (params: GtagParams = {}) =>
  trackEvent("portal_finder_complete", params);
